import React from "react";
const Footer = () => {
  return (
    <>
      <div
        className="footer"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <p>©{new Date().getFullYear()} Talk Home CRM. All rights reserved.</p>
      </div>
    </>
  );
};

export default Footer;
